var g_devtricker_comment_form_is_expanded = false;

document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('openOffcanvas') === 'true') {
        var offcanvasElement = document.getElementById('offcanvasComments');
        var bsOffcanvas = new bootstrap.Offcanvas(offcanvasElement);
        bsOffcanvas.show();

        urlParams.delete('openOffcanvas');
        let newUrl = window.location.pathname;
        if (urlParams.toString()) {
            newUrl += '?' + urlParams.toString();
        }
        newUrl += window.location.hash;
        history.pushState(null, '', newUrl);
    }
});

document.addEventListener('DOMContentLoaded', function () {

    devtricker_openLoginOrExpandTheCommentFieldOnClickInTextArea();
    devtricker_showSpinnerOnSubmitComment();
    devtricker_expandMarkdownOnMarkdownClick();

    devtricker_initializeOtherCommentOption();
    devtricker_expandCommentAreaOnClickInTextArea();

    let comment = document.querySelector('#comment');
    if (comment) {
        comment.addEventListener('input', devtricker_updateSubmitCommentIcon);
    }
});

function devtricker_showSpinnerOnSubmitComment() {
    const submitButton = document.getElementById('submit-comment-button');

    if (submitButton) {
        const form = submitButton.closest('form');
        if (form) {
            form.addEventListener('submit', function () {
                submitButton.innerHTML = '<div class="spinner-border" role="status" style="width: 20px; height: 20px;"></div>';
                submitButton.disabled = true;
            });
        }
    }
}

function devtricker_openLoginOrExpandTheCommentFieldOnClickInTextArea() {
    let textarea = document.querySelector('#comment-form-wrapper textarea');

    if (textarea) {
        textarea.addEventListener('click', function () {

            if (!devtricker_getTheLoggedUserId()) {
                devtricker_openSocialLoginModal();
            } else {

                if (!g_devtricker_comment_form_is_expanded) {
                    
                    g_devtricker_comment_form_is_expanded = true;
                }
            }
        });
    }
}

function devtricker_updateSubmitCommentIcon() {
    let submitButton = document.getElementById('submit-comment-button');

    let textarea = document.querySelector('#comment');
    if (textarea.value.trim().length > 0) {
        submitButton.disabled = false;
    } else {
        submitButton.disabled = true;
    }
}

function fetchNonce() {
    return fetch('/wp-admin/admin-ajax.php?action=devtricker_fetch_nonce', { credentials: 'same-origin' })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                return data.data.nonce;
            } else {
                devtricker_showCommentErrorToast();
            }
        })
        .catch(() => devtricker_showCommentErrorToast());;
}

function devtricker_showCommentErrorToast() {

    const commentDeletedToast = document.getElementById('comment-error-toast');

    if (commentDeletedToast) {
        const toastBootstrap = bootstrap.Toast.getOrCreateInstance(commentDeletedToast);
        toastBootstrap.show();
    }
}

function devtricker_initializeOtherCommentOption() {
    let comments = document.querySelectorAll('.comment-list .comment:not(.comment-other-option-initialized)');

    comments.forEach(comment => {

        comment.classList.add('comment-other-option-initialized');

        let header = comment.querySelector('header');

        let currentUserId = devtricker_getTheLoggedUserId();
        let dataAuthorId = comment.getAttribute('data-author-id');

        let optionsElement = devtricker_createMoreOptions(dataAuthorId, currentUserId);

        header.prepend(optionsElement);

    });
}

function devtricker_createMoreOptions(commentAuthorId, currentUserId) {

    let moreOptions =

        `
    <div class="dropdown comment-other-options">
        <button title="Comment options" class="btn text-body-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="true">
            <span class=" icon icon-more-horizontal dt-wh-1-25" ></span>
        </button>
        <ul class="dropdown-menu" style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate3d(0px, 29.3333px, 0px);" data-popper-placement="bottom-end">
            <li class="delete-comment-li" style="display: ${commentAuthorId == currentUserId ? 'block' : 'none'} ;">
                <button onclick="devtricker_deleteComment(event, this)" type="button" class="dropdown-item delete-comment fw-medium">
                    <span class=" icon icon-trash" ></span>
                    <span>${g_devtricker_i18n.delete}</span>
                </button>
            </li>
            <li>
                <button onclick="devtricker_reportComment(event, this)" type="button" class="dropdown-item report-comment fw-medium">
                    <span class=" icon icon-flag" ></span>
                    <span>${g_devtricker_i18n.report}</span>
                </button>
            </li>
        </ul>
    </div>        
    
    `;

    let tmp = document.createElement('div');
    tmp.innerHTML = moreOptions;

    return tmp.querySelector('.comment-other-options');
}

function devtricker_createCommentPlaceholder() {

    let placeholderHtml = `
        <div class="placeholder-glow" style="padding-top: 20px;">
            <div class='d-flex flex-row'>
                <div>
                    <span class="placeholder rounded-circle d-block" style="height: 2rem; width: 2rem;"></span>
                </div>
                <div>
                    <span class="placeholder col-7 d-block" style="height: 0.9375rem; margin-left: 5px; width: 122px;"></span>
                    <span class="placeholder col-7 d-block placeholder-xs" style="height: 0.75rem !important; margin-top: 3px; margin-left: 5px; width: 75px;"></span>
                </div>
            </div>

            <span class="placeholder col-8 d-block mt-3"></span>
            <span class="placeholder col-6 d-block mt-1"></span>
        </div>`;

    let temp = document.createElement('div');
    temp.innerHTML = placeholderHtml;

    return temp.querySelector('.placeholder-glow');
}

function devtricker_extractCommentsFromPlainTextHtml(htmlComments) {
    let temp = document.createElement('div');
    temp.innerHTML = htmlComments;

    return temp.querySelectorAll('.comment');
}

function devtricker_createIfNotExistsChildrenCommentList(parentSelector) {

    let commentListElement = document.querySelector(parentSelector);

    if (!commentListElement) {

        let commentParentSelector = parentSelector.split(' ');
        let commentParent = document.querySelector(commentParentSelector);

        commentList = document.createElement('ol');

        commentList.classList.add('children');

        commentParent.append(commentList);

        commentListElement = commentList;
    }

    return commentListElement;
}

function devtricker_insertPlaceholderComment_v2(parentSelector, atTheEnd = true) {

    let commentListElement = document.querySelector(parentSelector);

    if (!commentListElement) {

        let commentParentSelector = parentSelector.split(' ')[0];
        let commentParent = document.querySelector(commentParentSelector);

        let children = document.createElement('ol');

        children.classList.add('children');

        commentParent.append(children);

        commentListElement = children;
    }

    let depth = devtricker_calculateCommentListDepth(null, commentListElement);

    if (depth >= 2) {
        atTheEnd = true;
    }

    let li = document.createElement('li');
    li.id = 'main-thread-comment-placeholder';
    li.style.marginTop = '20px;';

    li.classList.add('comment');
    li.classList.add('p-0');

    li.append(devtricker_createCommentPlaceholder());

    if (atTheEnd) {
        commentListElement.append(li);
    } else {
        commentListElement.prepend(li);
    }

    return li;
}

function devtricker_incrementMainThreadCommentCounter(value) {
    let commentCounter = document.querySelector('.title-comment-number');

    if (commentCounter) {
        let currentCount = parseInt(commentCounter.textContent) || 0;

        currentCount += value;

        commentCounter.textContent = currentCount;
    }
}

function devtricker_collapseCommentForm() {
    var offcanvasFooter = document.querySelector('.offcanvas-footer');
    var commentForm = document.getElementById('comment-form-wrapper');
    var preview = document.getElementById('preview');
    var textarea = document.querySelector('.comment-form-comment textarea');
    var showPreviewButton = document.getElementById('preview-comment-button');
    var icon = showPreviewButton ? showPreviewButton.querySelector('span.icon') : null;

    if (offcanvasFooter && commentForm) {
        commentForm.classList.add('collapse');
    }

    if (textarea) textarea.style.display = 'block';
    if (preview) preview.style.display = 'none';

    window.g_devtricker_show_comment_preview = false;

    if (icon) {
        icon.classList.remove('icon-eye-off');
        icon.classList.add('icon-eye');
    }
}

function devtricker_expandCommentAreaOnClickInTextArea() {
    let element = document.querySelector('.comment-form-comment textarea');

    if (element) {
        element.addEventListener('click', function () {
            if (devtricker_getTheLoggedUserId()) {
                let commentForm = document.getElementById('comment-form-wrapper');
                commentForm.classList.remove('collapse');
            }
        });

    }
}

function devtricker_expandMarkdownOnMarkdownClick() {
    let markdownActionButton = document.getElementById('markdown-button');
    let markdownOptions = document.querySelector('.comment-markdown-emoji-wrapper-2');

    if (markdownActionButton) {
        markdownActionButton.addEventListener('click', function () {
            if (markdownOptions.style.display === 'flex') {
                markdownOptions.style.display = 'none';
            } else {
                markdownOptions.style.display = 'flex';
            }
        });
    }
}
